import api from './../utils/api';


export const sendCard = async (pin, seri, card_type, card_value) => {
    try {
        const response = await api.post(`/payment/send-card`,
            {
                pin,
                seri,
                card_type,
                card_value
            },
            {
                withCredentials: true
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};